const InvoiceDetailsPopupStyles = {
  paperProps: {
    borderRadius: '16px',
    maxHeight: '95vh',
    height: 'auto',
    width: '95vw',
    maxWidth: '1600px',
    boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden'
  },
  
  dialogTitle: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 3,
    borderBottom: `2px solid ${theme.palette.divider}`,
    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
    '& .MuiTypography-h6': {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: theme.palette.primary.main
    },
    '& .MuiIconButton-root': {
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
        color: 'error.main',
        transform: 'rotate(90deg)'
      }
    }
  }),
  
  tabsContainer: {
    borderBottom: `2px solid`,
    borderColor: 'divider',
    backgroundColor: '#fafbfc',
    boxShadow: 'inset 0 -2px 8px rgba(0, 0, 0, 0.02)'
  },
  
  tabs: (theme) => ({
    '& .MuiTabs-indicator': {
      height: '3px',
      borderRadius: '3px 3px 0 0',
      backgroundColor: theme.palette.primary.main,
      boxShadow: `0 -2px 8px ${theme.palette.primary.main}40`
    },
    '& .MuiTab-root': {
      fontWeight: 500,
      fontSize: '0.95rem',
      px: 3,
      py: 2,
      minHeight: '56px',
      textTransform: 'none',
      color: '#6b7280',
      transition: 'all 0.2s ease',
      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: 'rgba(25, 118, 210, 0.04)'
      },
      '&.Mui-selected': {
        fontWeight: 600,
        color: theme.palette.primary.main,
        backgroundColor: 'rgba(25, 118, 210, 0.06)'
      }
    }
  }),
  
  dialogContent: {
    p: 0,
    backgroundColor: '#ffffff'
  },
  
  dialogActions: (theme) => ({
    p: 2.5,
    borderTop: `2px solid ${theme.palette.divider}`,
    backgroundColor: '#f8f9fa',
    '& .MuiButton-outlined': {
      borderRadius: '10px',
      px: 3,
      py: 1.25,
      fontWeight: 600,
      fontSize: '0.95rem',
      color: '#6b7280',
      borderColor: '#d1d5db',
      borderWidth: '2px',
      textTransform: 'none',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#f3f4f6',
        borderColor: '#9ca3af',
        borderWidth: '2px',
        transform: 'translateY(-1px)'
      }
    }
  }),
  
  comparisonBox: {
    p: 3,
    backgroundColor: '#fafbfc',
    minHeight: '500px'
  },
  
  noDataBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    '& .MuiTypography-root': {
      fontSize: '1.1rem',
      color: '#9ca3af'
    }
  },
  
  fileViewerBox: {
    p: 3,
    backgroundColor: '#fafbfc'
  },
  
  retainerAlert: {
    mb: 3,
    p: 3,
    background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
    borderRadius: '16px',
    boxShadow: '0 4px 16px rgba(139, 92, 246, 0.15)',
    border: '2px solid',
    borderColor: 'rgba(139, 92, 246, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #8b5cf6 0%, #7c3aed 50%, #6d28d9 100%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 3s infinite',
      '@keyframes shimmer': {
        '0%': { backgroundPosition: '200% 0' },
        '100%': { backgroundPosition: '-200% 0' }
      }
    }
  },
  
  retainerHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 1.5
  },
  
  retainerIcon: {
    fontSize: '1.5rem',
    filter: 'drop-shadow(0 2px 4px rgba(139, 92, 246, 0.3))',
    animation: 'bounce 2s ease-in-out infinite',
    '@keyframes bounce': {
      '0%, 100%': { transform: 'translateY(0)' },
      '50%': { transform: 'translateY(-4px)' }
    }
  },
  
  retainerTitle: {
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#5b21b6',
    letterSpacing: '0.3px',
    textShadow: '0 1px 2px rgba(139, 92, 246, 0.1)'
  },
  
  retainerDescription: {
    color: '#6b21a8',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    fontWeight: 500,
    mb: 0.5
  },
  
  retainerSubDescription: {
    color: '#7e22ce',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    mb: 2
  },
  
  retainerInfoBox: {
    mt: 2,
    p: 2,
    bgcolor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(139, 92, 246, 0.08)',
    border: '1px solid rgba(139, 92, 246, 0.15)',
    background: 'linear-gradient(to bottom, #ffffff 0%, #faf5ff 100%)'
  },
  
  retainerInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,
    '&:last-child': {
      mb: 0
    }
  },
  
  retainerInfoLabel: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7e22ce',
    display: 'flex',
    alignItems: 'center',
    gap: 0.5
  },
  
  retainerInfoValue: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#8b5cf6',
    letterSpacing: '0.2px'
  },
  
  retainerDivider: {
    my: 1,
    borderColor: 'rgba(139, 92, 246, 0.15)'
  }
};

export default InvoiceDetailsPopupStyles;